import {ACTION_APPROVED} from "../actions/actionTypes";

const approved = (state = false, action) => {
    switch (action.type) {
        case ACTION_APPROVED:
            return action.value;
        default:
            return state;
    }
};

export default approved;



// WEBPACK FOOTER //
// ./src/reducers/approved.js